const dateformats ={
    getDay() {
        let today = new Date();
        let nowTime = today.getTime();
        let ms = 24 * 3600 * 1000;
        today.setTime(parseInt(nowTime - ms));
        let Year = today.getFullYear();
        let Month = today.getMonth();
        let Day = today.getDate().toString();
        let en_mon_arr = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        return Day + ' ' + en_mon_arr[Month] + ' ' + Year;
    },
    getFinancialYear() {
        let today = new Date();
        let nowTime = today.getTime();
        today.setTime(parseInt(nowTime));
        let Year = today.getFullYear();
        let Month = today.getMonth();
        if (Month >= 6) {
            return '1 Jul ' + Year + ' - 30 Jun ' + (Year + 1)
        }
        else {
            return '1 Jul ' + (Year - 1) + ' - 30 Jun ' + Year
        }
    },
    getThisFY(){
        let today = new Date();
        let nowTime = today.getTime();
        today.setTime(parseInt(nowTime));
        let Year = today.getFullYear();
        let Month = today.getMonth();
        if (Month >= 6) {
            return Year + 1
        }
        else {
            return Year
        }
    },
    AUformat(date){
        let year = date.slice(0,4);
        let month = date.slice(5,7);
        let day = date.slice(8,10)
        return day+'-'+month+'-'+year
    },
    getAge(dateString) {
        let today = new Date();
        let birthDate = new Date(dateString);
        let age = today.getFullYear() - birthDate.getFullYear();
        let m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
        return age;
    },
    getDateAndTime(dateString){
        let date = dateString.slice(0,10)
        let time = dateString.slice(11,19)
        let AUdate = this.AUformat(date)
        return AUdate+' '+time
    }
}
export default dateformats;